export const dk_DK = {
  translation: {
    add_to_cart: "Tilføj artikel til kurv",
    save: "Gem",
    load: "Indlæs artikel",
    title: "Konfiguration",
    type_key: "Typenøgle",
    start: "Start",
    generate_document: "Opret datablad",
    sap_button: "Opret artikel i SAP",
    cad_button: "Opret CAD-data",
    reset_configuration: "Nulstil konfiguration",
    show_additional_information: "Vis yderligere information",
    sap_title: "SAP",
    close_configuration_button: "Luk",
    no_results_found: "Ingen resultater fundet",
    load_configuration_dialog: {
      title: "Indlæs konfiguration – Indstil søgeparametre",
      cancel: "Annuller",
      search: "Søg",
      start_date: "Oprettelsesdato fra",
      end_date: "til",
      guid: "GUID",
      material_number: "Materialenummer",
      order_code: "Ordrekode",
      creator: "Opretter",
      description: "Beskrivelse",
      info_artikel: "Info-artikel",
      short_text: "Kort tekst",
      version: "Version",
      status: "Status",
      update_user: "Opdateret af",
      createdDate: "Oprettelsesdato",
      saved_records: "Gemte poster",
      back: "Tilbage",
      open: "Åbn",
      rows_per_page: "Rækker pr. side:",
    },
    error: {
      ERROR_LOAD_DATA_ERROR:
        "(INDLÆSNING) mislykkedes (data forkerte eller ufuldstændige)",
      ERROR_SAVE_DATA_ERROR:
        "(GEM) mislykkedes (data forkerte eller ufuldstændige)",
      ERROR_LOAD_ID: "ID til indlæsning blev ikke fundet",
      ERROR_LOAD_ID_CONFIG:
        "Fejl fra konfiguratoren ved indlæsning af et projekt",
      ERROR_LOADSTART_CONFIG: "Fejl fra konfiguratoren ved start",
      ERROR_MISSING_VALUES:
        "Generel fejlmeddelelse hvis validering af frontend-data mislykkes",
      ERROR_COOKIE_SERVICE_INITIAL:
        "Initialisering af cookie-service mislykkedes",
      ERROR_COOKIE_GENERAL: "Fejl i cookie-service",
      ERROR_TOKEN_NOT_FOUND: "Token ikke fundet",
      ERROR_ID_BLOCKED: "Elementet redigeres, ændringer ikke mulige",
      ERROR_DB_SAVE: "Fejl under lagring af data i databasen",
      ERROR_LOAD_VALID:
        "Indlæsning af konfiguration mislykkedes, data ugyldige",
      ERROR_NONE_LOAD_ID_FOUND_SAP_CHECK:
        "ID ikke fundet, SAP-tjek mislykkedes",
      ERROR_NONE_LOAD_ID_FOUND_ROWID_FROM_SHOPID:
        "Intet materialenummer fundet for ID fra shop-ID",
      ERROR_DELETE_CONFIGURATION: "Fejl ved sletning af konfiguration",
      ERROR_DEFINITION_SECRET_JWT: "JWT-definition mangler",
      ERROR_PATH_NOT_DEFINED: "Sti ikke defineret",
      ERROR_BACKLINK_URL: "Backlink-URL ikke defineret",
      ERROR_POSITIONDATA_EMPTY: "Positionsdata er tomme",
      ERROR_SHOP_ID: "Shop-ID ikke fundet",
      ERROR_CADBOXDATA_EMPTY: "Ingen CAD-boksdata fundet",
      ERROR_NONE_LOAD_ID_FOUND: "Ingen ID til indlæsning fundet",
      ERROR_NONE_ACCEPTABLE_ID: "Ingen acceptabel ID fundet",
    },
    sap: {
      create_error: "Fejl under oprettelse",
      create_success: "Oprettet",
    },
    button: {
      save: "Gem",
      cancel: "Annuller",
    },
  },
};

export default dk_DK;
